import React from 'react';
import PropTypes from 'prop-types';

import { AccordionBasicItem, ACCORDION_MARKER_VARIANTS, IconMapLazy } from '@ratehub/base-ui';


const WORDPRESS_EMPTY_CONTENT = '\n<div></div>\n';

function AccordionItem({
    content,
    marker, // default to undefined FOR NOW. Once showDot is removed from AccordionBasicItem, this should be MARKER_VARIANTS.NONE
    iconKey,
    showDot,
    number,
    children,
    ...otherProps
}) {
    return (
        <AccordionBasicItem
            marker={marker}
            iconKey={iconKey}
            showDot={showDot}
            number={number}
            {...otherProps}
        >
            {/* Deprecated - This is to support existing use cases where we only allowed a single rich text field
                Using an IF block here because content gets set to an empty DIV with inconsistent white space */}
            <If condition={content && content !== WORDPRESS_EMPTY_CONTENT}>
                <div
                    className="rich-text"
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{
                        __html: content,
                    }}
                />
            </If>
            {/* END Deprecated */}

            {children}
        </AccordionBasicItem>
    );
}

AccordionItem.propTypes = {
    content: PropTypes.string, // Deprecated - see note above
    marker: PropTypes.oneOf(Object.values(ACCORDION_MARKER_VARIANTS)),
    iconKey: PropTypes.oneOf(Object.keys(IconMapLazy)),
    showDot: PropTypes.bool,
    number: PropTypes.number,
    children: PropTypes.any,
};

AccordionItem.blockKey = 'rh/accordion-item';

export default AccordionItem;
